import axios from 'axios'

const clientApi = axios.create({
  baseURL: import.meta.env.VITE_API_CLIENT_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

clientApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  },
)

clientApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if ((error.response && error.response.status === 401) || (error.response && error.response.status === 500)) {
      localStorage.removeItem('access_token')
    }
  },
)

export default clientApi
